import React from "react";
import { useParentBg } from "../../shared/hooks/current-color";
import { useTheme } from "../ThemeProvider";
const Icon = (props) => {
  const {
    icon,
    size = "xl",
    color: propsColor,
    invisible,
    ...rest
  } = props;
  const parentBg = useParentBg();
  const { palette, icon: themeIcon } = useTheme();
  const color = propsColor ? palette[parentBg][propsColor] : "currentcolor";
  const wh = themeIcon.size[size];
  const iconSX = React.useMemo(() => ({
    visibility: invisible ? "hidden" : "visible",
    width: wh,
    height: wh,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fill: color,
    color,
    "& > svg": {
      color,
      fill: color
    }
  }), [size, color, wh]);
  const iconProps = React.useMemo(() => ({ rest, sx: iconSX }), [iconSX]);
  return React.cloneElement(icon, iconProps);
};
export {
  Icon
};
